import { render, staticRenderFns } from "./DocumentDetailUpload.vue?vue&type=template&id=71728f8a"
import script from "./DocumentDetailUpload.vue?vue&type=script&lang=js"
export * from "./DocumentDetailUpload.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailUpload.vue?vue&type=style&index=0&id=71728f8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports